export const SEO_PAGES_EXTERNAL_URL = 'https://motorway-ev-index.vercel.app';

export const SEO_PAGES_ROUTES = Object.freeze([
  '/best-ev-cities',
]);
